const localConfig = {
  API_URL: "http://localhost:8000",
  BASE_URL: "http://localhost:3000",
  firebase: {
    apiKey: "AIzaSyDh7bXRMH4OclDB0aJoJfsBbDwYHDMP2uc",
    authDomain: "sav-analysis.firebaseapp.com",
    projectId: "sav-analysis",
    messagingSenderId: "31471277098",
    appId: "1:31471277098:web:859ee464d6364deb695f53",
    measurementId: "G-FCF15WVDZK",
  },
  // logRocket: "'6kqagn/'",
  // storageBucket: "sav-analysis.appspot.com",
};
const devConfig = {
  API_URL: "http://localhost:5005",
  BASE_URL: "http://localhost:3000",
  firebase: {
    apiKey: "AIzaSyDh7bXRMH4OclDB0aJoJfsBbDwYHDMP2uc",
    authDomain: "sav-analysis.firebaseapp.com",
    projectId: "sav-analysis",
    messagingSenderId: "31471277098",
    appId: "1:31471277098:web:859ee464d6364deb695f53",
    measurementId: "G-FCF15WVDZK",
  },
  // storageBucket: "sav-analysis.appspot.com",
  // logRocket: "'6kqagn/'",
};

// Factury-prod config
const prodConfig = {
  // app engine
  // API_URL: "https://backend-dot-sav-analysis.ey.r.appspot.com",
  // cloud run
  API_URL: "https://backend-31471277098.europe-west1.run.app",
  BASE_URL: "https://audio.app.easierlabs.ai",
  firebase: {
    apiKey: "AIzaSyDh7bXRMH4OclDB0aJoJfsBbDwYHDMP2uc",
    authDomain: "sav-analysis.firebaseapp.com",
    projectId: "sav-analysis",
    messagingSenderId: "31471277098",
    appId: "1:31471277098:web:859ee464d6364deb695f53",
    measurementId: "G-FCF15WVDZK",
  },
  // storageBucket: "sav-analysis.appspot.com",
  // logRocket: "'6kqagn/'",
};

const devopsConfig = {
  API_URL: "https://backend-741054520814.europe-west1.run.app",
  BASE_URL: "https://sav-analysis.web.app",
  firebase: {
    apiKey: "AIzaSyCF0gPx0mNHzFhGUNQd9_wv9XHWDVNXwOI",
    authDomain: "audio-elwebapp-migration-test.firebaseapp.com",
    projectId: "audio-elwebapp-migration-test",
    messagingSenderId: "741054520814",
    appId: "1:741054520814:web:ab8450fef7198b6c1042ff",
  },
  // storageBucket: "audio-elwebapp-migration-test.firebasestorage.app",
  // logRocket: "'6kqagn/'",
};

const getConfig = () => {
  /* eslint-disable no-unreachable */
  return prodConfig;

  const penv = process.env;
  // cheking that the correct env variable are set
  if (penv.REACT_APP_BACKEND === undefined) {
    console.error("REACT_APP_BACKEND is not set");
    throw new Error("REACT_APP_BACKEND is not set");
  }
  if (penv.REACT_APP_BASE_URL === undefined) {
    console.error("REACT_APP_BASE_URL is not set");
    throw new Error("REACT_APP_BASE_URL is not set");
  }
  if (penv.REACT_APP_FIREBASE_API_KEY === undefined) {
    console.error("REACT_APP_FIREBASE_API_KEY is not set");
    throw new Error("REACT_APP_FIREBASE_API_KEY is not set");
  }
  if (penv.REACT_APP_FIREBASE_PROJECT_ID === undefined) {
    console.error("REACT_APP_FIREBASE_PROJECT_ID is not set");
    throw new Error("REACT_APP_FIREBASE_PROJECT_ID is not set");
  }
  if (penv.REACT_APP_FIREBASE_MESSAGING_SENDER_ID === undefined) {
    console.error("REACT_APP_FIREBASE_MESSAGING_SENDER_ID is not set");
    throw new Error("REACT_APP_FIREBASE_MESSAGING_SENDER_ID is not set");
  }
  if (penv.REACT_APP_FIREBASE_APP_ID === undefined) {
    console.error("REACT_APP_FIREBASE_APP_ID is not set");
    throw new Error("REACT_APP_FIREBASE_APP_ID is not set");
  }

  const firebase_project_id = penv.REACT_APP_FIREBASE_PROJECT_ID;
  const firebase_auth_domain = `${firebase_project_id}.firebaseapp.com`;
  const config = {
    API_URL: penv.REACT_APP_BACKEND,
    BASE_URL: penv.REACT_APP_BASE_URL,
    firebase: {
      apiKey: penv.REACT_APP_FIREBASE_API_KEY,
      authDomain: firebase_auth_domain,
      projectId: firebase_project_id,
      messagingSenderId: penv.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: penv.REACT_APP_FIREBASE_APP_ID,
    },
  };
  if (penv.REACT_APP_MEASUREMENT_ID !== undefined) {
    config.firebase.measurementId = penv.REACT_APP_MEASUREMENT_ID;
  }
  console.log("config: ", config);

  return devopsConfig;
};
export default getConfig;
